'use strict';
/**
 * @ngdoc function
 * @name formDesignerApp.controller:fdEditOverlayCtrl
 * @description
 * # fdEditOverlayCtrl
 * Controller of the edit overlay
 */

import * as angular from 'angular';

angular.module('formApp').controller('fdExternalDataSourceCtrl', [
  '$scope',
  '$timeout',
  'mappings',
  'resizeGuard',
  'elementHelper',
  'validationHelper',
  'formHelper',
  'constants',
  function ($scope, $timeout, mappings, resizeGuard, elementHelper, validationHelper, formHelper, constants) {
    $scope.init = function () {
      $scope.helpers = {
        element: elementHelper,
        validation: validationHelper,
        form: formHelper,
        constants: constants
      };
      if (!$scope.properties) {
        $scope.properties = {
          headers: {}
        };
      }
      $scope.mappings = angular.copy(mappings);
      $scope.isDownloadType = $scope.models.elementCopy.type === 'DOWNLOAD';
      $scope.models.dataSrc = $scope.properties.url === 'prozess' ? 'prozess' : 'external';

      if ($scope.properties.proxyHost && $scope.properties.proxyPort && !$scope.properties.proxyType) {
        $scope.properties.proxyType = 'MANUAL';
      }

      $scope.resetHeaderForm();
    };

    $scope.isExternalOrNotDownload = () => {
      return $scope.models.dataSrc === 'external' || !$scope.isDownloadType;
    };

    $scope.isManualProxyType = (proxyType) => {
      if (proxyType === 'MANUAL' && $scope.isExternalOrNotDownload()) {
        return true;
      }

      return false;
    };

    $scope.onDataSrcChange = () => {
      if ($scope.models.dataSrc === 'prozess') {
        $scope.properties.url = 'prozess';
      } else if ($scope.properties.url === 'prozess') {
        $scope.properties.url = '';
      }
    };

    $scope.possibleDataSourceScopes = {
      EMPTY: 'Keine Daten',
      CURRENT_FIELD: 'Wert des aktuellen Feldes',
      CURRENT_INSTANCE: 'Alle Werte aller Felder der aktuellen Feldgruppeninstanz',
      DEFINED: 'Werte definierter Formularfelder'
    };

    $scope.onChangeScope = function (properties) {
      if (properties.scope === 'DEFINED') {
        if (properties.fieldIds === undefined) {
          properties.fieldIds = [];
        }
      } else {
        delete properties.fieldIds;
      }
    };

    var _isAlreadyDefined = function (fieldGroup, field, properties, fieldGroupInstance) {
      var result = properties.fieldIds.some(function (definedField) {
        return (
          definedField.fieldId === field.id &&
          definedField.groupId === fieldGroup.id &&
          definedField.groupIndex === fieldGroupInstance
        );
      });

      return result;
    };

    $scope.addDefinedField = function (properties, definedField) {
      properties.fieldIds.push({
        fieldId: definedField.field.id,
        groupId: definedField.fieldGroup.id,
        groupIndex: definedField.instance
      });
    };

    $scope.onFieldGroupChange = function (element, properties, newDefinedField) {
      if (newDefinedField.fieldGroup.multiple) {
        if (newDefinedField.fieldGroup === $scope.models.containingFieldGroup) {
          newDefinedField.instance = -1;
        } else {
          newDefinedField.instance = 0;
        }
      } else {
        delete newDefinedField.instance;
      }
      $scope.setAvailableFields(element, properties, newDefinedField);
    };

    $scope.setAvailableFields = function (element, properties, newDefinedField) {
      var fields;
      if (newDefinedField && newDefinedField.fieldGroup) {
        fields = [];
        angular.forEach(newDefinedField.fieldGroup.rows, function (row) {
          fields = fields.concat(row.fields);
        });
      }

      if (!newDefinedField.fieldGroup.multiple) {
        newDefinedField.instance = 0;
      }

      fields = fields.filter(function (field) {
        // check for already defined fields
        if (_isAlreadyDefined(newDefinedField.fieldGroup, field, properties, newDefinedField.instance)) {
          return false;
        }
        return true;
      });

      newDefinedField.availableFields = fields;
    };

    $scope.addHeader = function () {
      $scope.properties.headers[$scope.models.headerForm.item.key] = $scope.models.headerForm.item.value;
      $scope.resetHeaderForm();
    };

    $scope.deleteHeader = function (key) {
      delete $scope.properties.headers[key];
    };

    $scope.editHeader = function (key) {
      $scope.models.headerForm = {
        item: {
          key: key,
          value: $scope.properties.headers[key]
        },
        keyEditing: key
      };
    };

    $scope.updateHeader = function () {
      if ($scope.models.headerForm.item.key !== $scope.models.headerForm.keyEditing) {
        $scope.deleteHeader($scope.models.headerForm.keyEditing);
      }
      $scope.addHeader();
    };

    $scope.resetHeaderForm = function () {
      $scope.models.headerForm = {
        item: {
          key: '',
          value: ''
        }
      };
    };

    $scope.init();
  }
]);
